"use strict";

require("core-js/modules/es6.object.define-property");

var _styledComponents = _interopRequireDefault(require("styled-components"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Padder = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var Padder = _styledComponents["default"].div.withConfig({
  displayName: "styles__Padder"
})(["", ";", ";", ";"], function (a) {
  return "small" === a.size && "padding: 1rem 0";
}, function (a) {
  return "regular" === a.size && "padding: 2rem 0";
}, function (a) {
  return "big" === a.size && "padding: 3rem 0";
});

exports.Padder = Padder;